import { TRANSFORM_SSR_STATE, TransformSSRState } from 'app/redux/ssrState';

import {
  AutoUpdateActiveStakes,
  autoUpdateActiveStakes,
  CLEANUP_ACTIVE_STAKES, CleanupActiveStakes,
  FetchActiveStakes,
  fetchActiveStakesService,
  TOGGLE_AUTO_UPDATE, ToggleAutoUpdate,
} from '../actions/activeStakes';
import type { ActiveStakesState } from '../types/activeStakes';
import type { EntriesState } from '../types/entries';
import cashoutReducer, { CashoutActions } from '../utils/cashout-reducer';
import { applyEntries, createStakeListReducer, initialState as generalState } from '../utils/entries-reducer';
import setupEntryError from '../utils/setup-entry-error';

// ---

type ActiveStakesActions =
  | TransformSSRState<EntriesState>
  | ToggleAutoUpdate
  | CleanupActiveStakes
  | CashoutActions;

const activeStakes = createStakeListReducer({
  REQUEST: fetchActiveStakesService.pending.type,
  SUCCESS: 'NOT_EXISTING_ACTION',
  FAILURE: fetchActiveStakesService.rejected.type,
  CLEANUP: CLEANUP_ACTIVE_STAKES,
});

function insertSavedCashOutErrors(
  state: ActiveStakesState,
  action: ActiveStakesActions,
): ActiveStakesState {
  const { payload } = action as FetchActiveStakes;

  const newState = {
    ...state,
    loading: false,
    requested: true,
    entries: applyEntries(state.entries, payload.data.activeStakes),
  };

  const savedCashOutErrors = payload.data.savedCashOutErrors;
  if (!savedCashOutErrors) {
    return newState;
  }

  let entries = newState.entries;

  newState.entries.forEach((entry) => {
    if (entry.id !== null && entry.id in savedCashOutErrors) {
      const error = savedCashOutErrors[entry.id];
      entries = entries.set(entry.id, setupEntryError(entry, { error }));
    }
  });

  return { ...newState, entries };
}

const initialState = {
  ...generalState,
  autoUpdate: false,
};

export default function (
  state = initialState,
  action: ActiveStakesActions,
): ActiveStakesState {
  switch (action.type) {
    case TRANSFORM_SSR_STATE:
    case fetchActiveStakesService.pending.toString():
    case fetchActiveStakesService.rejected.toString():
    case CLEANUP_ACTIVE_STAKES:
      return activeStakes(state, action);

    case fetchActiveStakesService.fulfilled.toString(): {
      return insertSavedCashOutErrors(state, action);
    }

    case TOGGLE_AUTO_UPDATE: {
      return {
        ...state,
        autoUpdate: !state.autoUpdate,
      };
    }

    case autoUpdateActiveStakes.fulfilled.toString(): {
      const { payload } = action as AutoUpdateActiveStakes;
      return {
        ...state,
        entries: applyEntries(state.entries, payload.data.activeStakes),
      };
    }

    default:
      return cashoutReducer(state, action);
  }
}
